import React from "react";
import { Sparkles } from "lucide-react";

export const AiBadge = ({ compact = false, testId = "ai-badge" }) => compact ? (
  <span className="hidden md:inline-flex items-center gap-1.5 rounded-full border border-accent/40 bg-accent/10 px-3 py-1.5 text-xs font-bold text-accent" data-testid={testId}
    title="رواج الذكية منصة ذكية بالكامل: صمّم استراتيجيتك وتسويقك بتجربة الذكاء الاصطناعي">
    <Sparkles className="w-3.5 h-3.5 animate-pulse" /> {localStorage.getItem("rawaj_lang") === "en" ? "Fully AI-powered" : "ذكي بالكامل · AI"}
  </span>
) : (
  <div className="inline-flex items-center gap-3 rounded-2xl border border-accent/40 bg-accent/10 px-4 py-2.5 mb-4" data-testid={testId}>
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-accent/20"><Sparkles className="w-4 h-4 text-accent animate-pulse" /></span>
    <span className="leading-snug">
      <span className="block text-sm font-extrabold text-accent">منصة ذكية بالكامل · 100% AI</span>
      <span className="block text-xs text-muted-foreground">أنت تصمّم استراتيجيتك وتسويقك بتجربة الذكاء الاصطناعي</span>
    </span>
  </div>
);
